import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../core/i18n';
import { PrincipalConfigurationDirectiveModule } from '../../directives';
import { PipesModule } from '../../pipes';
import { BadgeModule } from '../badge';
import { SpinnerModule } from '../spinner';
import { ArticlePriceComponent } from './article-price.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    NzIconModule,
    PipesModule,
    NgbTooltipModule,
    PrincipalConfigurationDirectiveModule,
    SpinnerModule,
    BadgeModule,
  ],
  declarations: [ArticlePriceComponent],
  exports: [ArticlePriceComponent],
})
export class ArticlePriceModule {}
